module.exports = __webpack_public_path__ + "static/media/screenshot_history_3_en.328882f1.png";